<template>
  <div class="">
    <v-layout row wrap v-if="$currentUrl === 'RegisterMember'">
      <v-flex lg1 md1 sm6 xs12>
        <v-container>
          <v-btn small @click="back()" :depressed="true" block color="secondary"
            >Back</v-btn
          >
        </v-container>
      </v-flex>
      <v-flex lg2 md2 sm6 xs12>
        <v-container>
          <v-btn
            @click="resetData()"
            color="error"
            :depressed="true"
            block
            small
            flat
            >I want to Start Over</v-btn
          >
        </v-container>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex lg4 hidden-md-and-below>
        <membership-cart style="margin-top: 20%"></membership-cart>
      </v-flex>
      <v-flex lg8 md12>
        <v-container fluid>
          <div class="" v-if="$currentUrl === 'RegisterMember'">
            <h1 class="text-md-center earth-color">BECOME A MEMBER</h1>
            <br />
            <h3 class="text-md-center">
              Members required to show proof of ID when visiting the
              Conservancy.
            </h3>
            <br />
          </div>
          <div class="" v-else>
            <h1 class="text-md-center earth-color">ADD AN EXISTING MEMBER</h1>
          </div>
          <v-form @submit.prevent="postPublicMember()">
            <v-card flat>
              <v-container fluid>
                <v-layout row wrap>
                  <v-flex lg4 md4 sm12 xs12 v-if="$currentUrl === 'NewMember'">
                    <v-container>
                      <v-select
                        label="Membership Type *"
                        v-model="residence"
                        @change="getResidence"
                        :items="allMemberSettings"
                        item-text="custom_name"
                        :return-object="true"
                        required
                        :loading="$loadingTrue"
                      ></v-select>
                    </v-container>
                  </v-flex>
                  <v-flex
                    lg4
                    md4
                    sm12
                    xs12
                    v-if="$currentUrl === 'RegisterMember'"
                  >
                    <v-container>
                      <v-select
                        label="Membership Type *"
                        v-model="residence"
                        @change="getResidence"
                        :items="allGreenMemberSettings"
                        item-text="custom_name"
                        :return-object="true"
                        required
                        :loading="$loadingTrue"
                      ></v-select>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-select
                        label="Residency *"
                        v-model="member.residence"
                        @change="getResidence"
                        :items="selectedResidence"
                        item-text="name[0]"
                        item-value="public_id"
                        required
                        :loading="$loadingTrue"
                      ></v-select>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-select
                        label="Type of Household"
                        v-model="member.household_type"
                        :items="allHouseHoldTypes"
                        item-text="name"
                        item-value="public_id"
                        required
                        :loading="$loadingTrue"
                      ></v-select>
                    </v-container>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
            <br />
            <v-card flat>
              <v-container fluid>
                <v-layout row wrap>
                  <v-flex lg4 md4 sm12 xs12 v-if="$currentUrl === 'NewMember'"
                    ><v-container>
                      <v-text-field
                        label="Member ID"
                        v-model="member.member_id"
                        required
                      ></v-text-field> </v-container
                  ></v-flex>
                  <v-flex lg4 md4 sm12 xs12 v-if="$currentUrl === 'NewMember'"
                    ><v-container>
                      <v-text-field
                        label="Salesforce Opportunity ID"
                        v-model="member.salesforce_id"
                        required
                      ></v-text-field> </v-container
                  ></v-flex>
                  <v-flex lg4 md4 sm12 xs12 v-if="$currentUrl === 'NewMember'"
                    ><v-container>
                      <v-text-field
                        label="Salesforce Account ID"
                        v-model="member.salesforce_account_id"
                        required
                      ></v-text-field> </v-container
                  ></v-flex>
                  <v-flex lg4 md4 sm12 xs12 v-if="$currentUrl === 'NewMember'"
                    ><v-container>
                      <v-text-field
                        label="Salesforce Contact ID"
                        v-model="member.salesforce_contact_uuid"
                        required
                      ></v-text-field> </v-container
                  ></v-flex>
                  <v-flex lg4 md4 sm12 xs12 v-if="$currentUrl === 'NewMember'">
                    <v-container>
                      <v-dialog
                        ref="dialog2"
                        persistent
                        v-model="modal2"
                        lazy
                        full-width
                        width="290px"
                        :return-value.sync="member.expiry_date"
                      >
                        <v-text-field
                          slot="activator"
                          label="Membership Expiry Date"
                          v-model="member.expiry_date"
                          :rules="requiredRules"
                          readonly
                        ></v-text-field>
                        <v-date-picker v-model="member.expiry_date" scrollable>
                          <v-spacer></v-spacer>
                          <v-btn
                            :depressed="true"
                            flat
                            color="primary"
                            @click="modal2 = false"
                            >Cancel</v-btn
                          >
                          <v-btn
                            :depressed="true"
                            flat
                            color="primary"
                            @click="$refs.dialog2.save(member.expiry_date)"
                            >OK</v-btn
                          >
                        </v-date-picker>
                      </v-dialog>
                    </v-container></v-flex
                  >
                  <v-flex lg4 md4 sm12 xs12
                    ><v-container>
                      <v-select
                        label="Title"
                        v-model="member.title"
                        :items="['Mr.', 'Mrs.', 'Ms.', 'Dr.', 'Eng.', 'Prof.']"
                        :rules="[(v) => !!v || 'Title method is required']"
                        required
                        :loading="$loadingTrue"
                      ></v-select> </v-container
                  ></v-flex>
                  <v-flex lg4 md4 sm12 xs12
                    ><v-container>
                      <v-text-field
                        v-model="member.first_name"
                        :rules="requiredRules"
                        label="First Name"
                        required
                      ></v-text-field> </v-container
                  ></v-flex>
                  <v-flex lg4 md4 sm12 xs12
                    ><v-container>
                      <v-text-field
                        v-model="member.sur_name"
                        :rules="requiredRules"
                        label="Last Name"
                        required
                      ></v-text-field> </v-container
                  ></v-flex>
                  <v-flex lg4 md4 sm12 xs12
                    ><v-container>
                      <v-select
                        label="Gender"
                        v-model="member.gender_id"
                        :items="allGender"
                        :rules="[(v) => !!v || 'Gender is required']"
                        item-text="name"
                        item-value="public_id"
                        required
                        :loading="$loadingTrue"
                      ></v-select> </v-container
                  ></v-flex>
                  <v-flex lg4 md4 sm12 xs12
                    ><v-container>
                      <v-dialog
                        ref="dialog"
                        persistent
                        v-model="modal1"
                        lazy
                        full-width
                        width="290px"
                        :return-value.sync="member.dob"
                      >
                        <v-text-field
                          slot="activator"
                          label="Date of Birth"
                          v-model="member.dob"
                          :rules="requiredRules"
                          readonly
                        ></v-text-field>
                        <v-date-picker
                          v-model="member.dob"
                          :max="start_date"
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            :depressed="true"
                            flat
                            color="primary"
                            @click="modal1 = false"
                            >Cancel</v-btn
                          >
                          <v-btn
                            :depressed="true"
                            flat
                            color="primary"
                            @click="$refs.dialog.save(member.dob)"
                            >OK</v-btn
                          >
                        </v-date-picker>
                      </v-dialog>
                    </v-container></v-flex
                  >
                  <v-flex lg4 md4 sm12 xs12
                    ><v-container>
                      <v-text-field
                        v-model="member.id_alien_number"
                        label="ID Number/Alien ID (Required for every visit)"
                      ></v-text-field> </v-container
                  ></v-flex>
                  <v-flex lg4 md4 sm12 xs12
                    ><v-container>
                      <v-text-field
                        v-model="member.town"
                        :rules="requiredRules"
                        label="Town"
                        required
                      ></v-text-field> </v-container
                  ></v-flex>
                  <v-flex lg4 md4 sm12 xs12
                    ><v-container>
                      <v-text-field
                        v-model="member.postal_address"
                        :rules="requiredRules"
                        label="Postal Address"
                        required
                      ></v-text-field> </v-container
                  ></v-flex>
                  <v-flex lg4 md4 sm12 xs12
                    ><v-container>
                      <v-text-field
                        v-model="member.postal_code"
                        :rules="requiredRules"
                        label="Postal Code"
                        required
                      ></v-text-field> </v-container
                  ></v-flex>
                  <v-flex lg4 md4 sm12 xs12
                    ><v-container>
                      <v-text-field
                        v-model="member.email"
                        :rules="requiredRules"
                        label="Email"
                        required
                        type="email"
                      ></v-text-field> </v-container
                  ></v-flex>
                  <v-flex lg3 md6 sm12 xs12>
                    <v-container>
                      <v-autocomplete
                        label="Country"
                        v-model="member.code"
                        :items="allCountries"
                        :rules="[(v) => !!v || 'Country is required']"
                        required
                        item-text="name"
                        item-value="code"
                        @change="findCountryCode"
                        :loading="$loadingTrue"
                      ></v-autocomplete>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12
                    ><v-container>
                      <v-text-field
                        v-model="member.tel_number"
                        :rules="requiredRules"
                        label="Phone Number (e.g. +XXX...)"
                        required
                        minlength="13"
                        type="text"
                      ></v-text-field> </v-container
                  ></v-flex>
                  <v-flex lg5 md5 sm12 xs12 v-if="$currentUrl === 'NewMember'">
                    <v-container>
                      <v-select
                        label="Payment Method"
                        v-model="member.payment_method"
                        :items="[
                          'Mpesa',
                          'Credit Card',
                          'Bank Transfer',
                          'Cheque',
                          'Voucher',
                        ]"
                        required
                        :loading="$loadingTrue"
                      ></v-select>
                    </v-container>
                  </v-flex>
                </v-layout>
                {{ updateResidencyAndHousehold }}
              </v-container>
              <br />
              <v-card flat v-if="membershipRegistrationTotal > 1">
                <add-beneficiary
                  :residence="residence"
                  :email="member.email"
                ></add-beneficiary>
              </v-card>
              <v-container v-if="$currentUrl === 'NewMember'">
                <v-switch
                  color="primary"
                  label="Is Paid"
                  v-model="member.payment_status"
                  required
                ></v-switch>
              </v-container>
              <v-btn
                :depressed="true"
                color="primary"
                type="submit"
                block
                large
                :loading="this.$store.state.LoadingStore.loading"
                >Complete Registration</v-btn
              >
            </v-card>
          </v-form>
        </v-container>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import FrontNavigation from "../Repeated/FrontNavigation";
import MembershipCart from "../Repeated/MembershipCart";
import Datepicker from "vuejs-datepicker";
import AddBeneficiary from "../Repeated/AddBeneficiary";
export default {
  name: "register-member",
  data() {
    return {
      start_date: this.$moment().subtract(18, "years").format("YYYY-MM-DD"),
      requiredRules: [(v) => !!v || "This field is required"],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      valid: true,
      menu1: false,
      modal1: false,
      modal2: false,
      dob_config: {
        maxDate: this.$moment().subtract(18, "years").format("YYYY-MM-DD"),
      },
      dob_config2: {
        maxDate: "today",
      },
      member: {
        member_id: "",
        salesforce_id: "",
        salesforce_uuid: "",
        payment_status: false,
        expiry_date: "",
        member_setting: "",
        registration_type: "76f0a89",
        title: "",
        first_name: "",
        sur_name: "",
        email: "",
        code: "",
        tel_number: "",
        registration_date: "",
        member_id: "",
        postal_address: "",
        id_alien_number: "",
        gender_id: "",
        postal_code: "",
        payment_method: "",
        dob: this.$moment().subtract(18, "years").format("YYYY-MM-DD"),
        residence: "berbere",
        household_type: "",
        children: "",
        promo_code: "",
        family: [],
        town: "",
        salesforce_account_uuid: "",
        salesforce_contact_uuid: "",
      },
      residence: {},
      existing_member: false,
      household: false,
    };
  },
  components: {
    AddBeneficiary,
    Datepicker,
    MembershipCart,
    FrontNavigation,
  },
  created() {
    this.$store.dispatch("get_all_countries");
    this.$store.dispatch("get_all_membership_settings");
    this.$store.dispatch("get_all_genders");
    this.$store.dispatch("get_all_green_membership_settings");
  },
  computed: {
    updateResidencyAndHousehold() {
      this.updateRAndH();
      return null;
    },
    disabled_settings: function () {
      return {
        from: new Date(
          this.$moment().subtract(18, "years").format("YYYY, MM, DD")
        ),
      };
    },
  },
  methods: {
    findCountryCode(data) {
      var instance = this;
      this.allCountries.map(function (country) {
        if (data === country.code) {
          instance.member.tel_number = "+" + country.calling_code;
        }
      });
    },
    getResident(setting) {
      return "";
    },
    resetData() {
      this.$store.commit("GET_RESIDENCE_TYPES", { data: [] });
      this.$store.commit("CLEAR_BENEFICIARIES");
      this.$store.commit("CLEA_LOCAL_MEMBERS");
      this.beneficiary = {
        ltitle: "",
        lfirst_name: "",
        lsur_name: "",
        lgender_id: "",
        ldob: "",
        lid_alien_number: "",
        lemail: "",
        lpostal_address: "",
        lpostal_code: "",
        lphone_number: "",
      };
      this.member = {
        member_id: "",
        salesforce_id: "",
        payment_status: false,
        expiry_date: "",
        member_setting: "",
        registration_type: "76f0a89",
        title: "",
        first_name: "",
        sur_name: "",
        email: "",
        tel_number: "",
        registration_date: "",
        member_id: "",
        postal_address: "",
        id_alien_number: "",
        gender_id: "",
        postal_code: "",
        dob: "",
        residence: "berbere",
        household_type: "",
        children: "",
        promo_code: "",
        family: [],
        member_reference_number: "",
      };
      this.residence = {};
      this.existing_member = false;
      this.household = false;
    },
    updateRAndH() {
      if (this.selectedResidence.length > 0) {
        this.member.residence = this.selectedResidence[0].public_id;
      }
      if (this.allHouseHoldTypes.length > 0) {
        this.member.household_type = this.allHouseHoldTypes[0].public_id;
      }
    },
    formatDob: function () {
      this.program.dob = this.$moment(this.member.dob).format("YYYY-MM-DD");
    },
    getResidence: function (data) {
 
      this.residence = data;
      this.member.member_setting = this.residence.public_id;
      this.$store.commit("GET_LOCAL_MEMBERS", this.residence);
      this.$store.dispatch("get_residence_types", this.residence.public_id);
      this.$store.dispatch("get_setting_household", this.residence.public_id);
    },
    getHousehold: function () {
      var household = this.member.household_type;
      if (household === "jnjker") {
        this.household = false;
      } else {
        this.household = true;
      }
    },
    getmembership: function () {
      if (this.member.registration_type === "5d73c26") {
        this.existing_member = true;
      } else {
        this.existing_member = false;
      }
    },
    postPublicMember: function () {
      if (this.member.dob === "") {
        alert("Date of birth cannot be null");
      } else {
        let ref_number = this.generateRandomUUid();
        this.member.member_reference_number = ref_number;
        this.member.dob = this.$moment(this.member.dob).format("YYYY-MM-DD");
        this.member.family = this.allBeneficiaries;
        if (this.$currentUrl === 'NewMember') {
          
          this.$store.dispatch('post_existing_member', this.member)
        } else {
          this.$store.dispatch('post_public_member', this.member)
        }
        // this.$store.dispatch("post_public_member", this.member);
      }
    },
    generateRandomUUid: function () {
      var firstPart = (Math.random() * 46656) | 0;
      var secondPart = (Math.random() * 46656) | 0;
      firstPart = ("000" + firstPart.toString(36)).slice(-3);
      secondPart = ("000" + secondPart.toString(36)).slice(-3);
      return firstPart + secondPart;
    },
  },
};
</script>

<style scoped>
.spacing {
  margin-left: 6%;
}
</style>
